import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@/components/ui/dialog";
import { lenisStore } from "@/lib/scroll";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import CoreServicesSection from "@/components/CoreServicesSection";
import ProductsSection from "@/components/ProductsSection";
import WhyChooseSection from "@/components/WhyChooseSection";
import CommunitySection from "@/components/CommunitySection";
import MissionSection from "@/components/MissionSection";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";
import { LEGAL_DOCS } from "@/data/content";

function App() {
    const [legalDoc, setLegalDoc] = useState(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisStore.current = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            lenisStore.current = null;
        };
    }, []);

    const doc = legalDoc ? LEGAL_DOCS[legalDoc] : null;
    const isAdminPath = window.location.pathname.startsWith("/admin");

    if (isAdminPath) {
        return (
            <div className="App bg-[#080B12] text-[#F8F5EE]">
                <AdminPage />
                <Toaster position="top-center" richColors closeButton />
            </div>
        );
    }

    return (
        <div className="App bg-[#080B12] text-[#F8F5EE]">
            <Header />
            <main>
                <HeroSection />
                <AboutSection />
                <EditorialMarquee />
                <CoreServicesSection />
                <ProductsSection />
                <WhyChooseSection />
                <CommunitySection onOpenLegal={setLegalDoc} />
                <MissionSection />
            </main>
            <Footer onOpenLegal={setLegalDoc} />

            <Dialog open={!!legalDoc} onOpenChange={(open) => !open && setLegalDoc(null)}>
                <DialogContent
                    data-testid="legal-dialog"
                    className="max-h-[80vh] overflow-y-auto border-[#D9A441]/40 bg-[#0B0E18] text-[#F8F5EE] sm:max-w-xl"
                >
                    {doc && (
                        <>
                            <DialogHeader>
                                <DialogTitle className="font-display text-xl tracking-wide text-[#F4C46B]">
                                    {doc.title}
                                </DialogTitle>
                                <DialogDescription className="sr-only">{doc.title} for ISelfLawAmMaster</DialogDescription>
                            </DialogHeader>
                            <div className="space-y-4 text-sm leading-relaxed text-[#F8F5EE]/70">
                                {doc.body.map((paragraph, i) => (
                                    <p key={i}>{paragraph}</p>
                                ))}
                            </div>
                        </>
                    )}
                </DialogContent>
            </Dialog>

            <Toaster position="top-center" richColors closeButton />
        </div>
    );
}

export default App;
